import React, {useState, Fragment, useEffect, useContext} from "react";

import ActionButton from "root/Wieldy/ApplicationModules/Common/Components/ActionButton";
import useModalUpdateChild from "root/Modals/UpdateChildDetails/useModalUpdateChild";
import {childNameAtom} from "root/recoil/childName";
import "./ChildInfoForm.scss";
import {getChildDetails, getChildImageUrl} from "root/DataFunctions/ChildDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {useSetRecoilState} from "recoil";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

const ChildInfoForm = (props) => {
    const [data, setData] = useState({isLoading: true, data: []});
    const setChildName = useSetRecoilState(childNameAtom);

    useEffect(() => {
        getData();
    }, [props.child_uid]);

    const getData = () => {
        if (props.child_uid !== undefined)
        {
            getChildDetails(props.child_uid, (response) =>
            {
                let childData = getDataFromResponse(response)[0];
                setData({isLoading: false, data: childData});

                // Set the recoil childNameAtom to the first child
                setChildName(childData.firstname + " " + childData.surname);
            });
        }
    }

    const childFullName = data.data.firstname + " " + data.data.surname;

    const getChildAdoptedName = () =>
    {
        let childAdoptedName = '';

        if (data.data.adopted_firstname !== null)
        {
            childAdoptedName = data.data.adopted_firstname + " " + data.data.adopted_surname;
        }

        return childAdoptedName;
    }


    const onSaveUpdateChildCompleted = (key) =>
    {
        getData();
    }

    const [renderUpdateChildDetailsModal, onActivateUpdateChildDetailsModal] = useModalUpdateChild(onSaveUpdateChildCompleted);

    return (
        <Fragment>
            <div className="child-info-page-layout">
                <div className="dt-card dt-card__full-height">

                    <div className="dt-card__body">

                        <div className="media">
                            <div className="media-body align-self-center">
                                {props.match.child_uid !== undefined &&
                                    <div>
                                        <h2 className="mb-1">{childFullName}</h2>
                                        <span className="d-block text-light-gray">{data.data.acs_status}</span>
                                    </div>
                                }

                                { /* This isn't the place to display this message */

                                    /* props.child_uid === undefined &&
                                    <h2 className="mb-1">You currently have no children assigned!</h2> */}

                            </div>
                        </div>

                        { data.isLoading === false &&
                            <div>
                                <div className="card-text">
                                    <div>
                                        <img src={getChildImageUrl(data.data.document_id, data.data.idusers)}
                                             style={{width: '150px'}}/>
                                    </div>

                                    <div className="child-info">
                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <label>Full Name</label>
                                                <div className='form-control'>{childFullName}</div>
                                            </div>
                                            <div className='col-md-4'>
                                                <label>Adopted Name</label>
                                                <div className='form-control'>{getChildAdoptedName()}</div>
                                            </div>
                                            <div className='col-md-4'>
                                                <label>Username</label>
                                                <div className='form-control'>{data.data.username}</div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <label>Organisation</label>
                                                <div className='form-control readonly'>{data.data.organisation}</div>
                                            </div>
                                            <div className='col-md-4'>
                                                <label>Date Of Birth</label>
                                                <div className='form-control'>{data.data.dob}</div>
                                            </div>
                                            <div className='col-md-4'>
                                                <label>Care Status</label>
                                                <div className='form-control'>{data.data.status}</div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <label>Team</label>
                                                <div className='form-control'>{data.data.teamlist}</div>
                                            </div>
                                            <div className='col-md-4'>
                                                <label>Post Identifier</label>
                                                <div className='form-control'>{data.data.description}</div>
                                            </div>
                                            <div className='col-md-4'>
                                                <label>Email</label>
                                                <div className='form-control'>{data.data.email}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ActionButton icon='icon-edit' onClick={() => onActivateUpdateChildDetailsModal(props.child_uid, 'edit')}
                                              title="Update"/>
                                {renderUpdateChildDetailsModal(props)}
                            </div>
                        }
                        {data.isLoading === true && <SpinnerDiv/>}
                    </div>

                </div>

            </div>

        </Fragment>
    );
};

export default ChildInfoForm;
